module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-progress weex-ct weex-div",
    style: (_vm._px2rem(_vm.runWayStyle, 75)),
    attrs: {
      "accessible": true,
      "aria-label": ("进度为百分之" + _vm.value),
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "progress weex-ct weex-div",
    style: (_vm._px2rem(_vm.progressStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57db9c68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57db9c68","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-progress/index.vue
// module id = 615
// module chunks = 0 1